var api = require("!../../../../../../node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js");
            var content = require("!!../../../../../../node_modules/css-loader/dist/cjs.js!../../../../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../../../../node_modules/sass-loader/lib/loader.js??ref--2-2!../../../../../../node_modules/style-resources-loader/lib/index.js??ref--2-3!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./service-worker-update-popup.vue?vue&type=style&index=0&id=68047b6e&lang=scss&scoped=true&");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.id, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);

var exported = content.locals ? content.locals : {};



module.exports = exported;